// Mock data untuk YPPSDP
// Konten disesuaikan dengan yppsdp.id (Yayasan Pengembangan Potensi Sumber Daya Pertahanan)
// yang menaungi LPTTN (Lembaga Perguruan Taman Taruna Nusantara) dan SMA Taruna Nusantara

export const navigation = [
  {
    label: { id: 'Tentang Kami', en: 'About Us' },
    children: [
      { label: { id: 'Sejarah Yayasan', en: 'History' }, href: '/tentang' },
      { label: { id: 'Visi & Misi', en: 'Vision & Mission' }, href: '/tentang#visi' },
      { label: { id: 'Struktur Organisasi', en: 'Organization Structure' }, href: '/tentang#struktur' },
      { label: { id: 'Nilai Inti', en: 'Core Values' }, href: '/tentang#nilai' },
    ],
  },
  {
    label: { id: 'Pengurus', en: 'Leadership' },
    children: [
      { label: { id: 'Pengurus YPPSDP', en: 'YPPSDP Board' }, href: '/pimpinan' },
      { label: { id: 'Pengurus LPTTN', en: 'LPTTN Board' }, href: '/pimpinan' },
      { label: { id: 'Dewan Pembina', en: 'Board of Trustees' }, href: '/pimpinan' },
    ],
  },
  {
    label: { id: 'LPTTN', en: 'LPTTN' },
    children: [
      { label: { id: 'Tentang LPTTN', en: 'About LPTTN' }, href: '/lpttn' },
      { label: { id: 'SMA Taruna Nusantara', en: 'SMA Taruna Nusantara' }, href: '/lpttn#smatn' },
      { label: { id: 'Sejarah', en: 'History' }, href: '/lpttn#sejarah' },
      { label: { id: 'Kampus SMA TN', en: 'SMA TN Campuses' }, href: '/lpttn#kampus' },
      { label: { id: 'Penerimaan Siswa Baru', en: 'Admission' }, href: '/lpttn#pensis' },
    ],
  },
  {
    label: { id: 'Direktorat', en: 'Directorates' },
    children: [
      { label: { id: 'Dir. Pendidikan Tinggi', en: 'Higher Education' }, href: '/tentang#struktur' },
      { label: { id: 'Dir. Perumahan & Sosial', en: 'Housing & Social' }, href: '/tentang#struktur' },
      { label: { id: 'Dir. Investasi & Usaha', en: 'Investment & Business' }, href: '/tentang#struktur' },
      { label: { id: 'Divisi Hukum', en: 'Legal Division' }, href: '/tentang#struktur' },
      { label: { id: 'Satuan Pengawas Internal', en: 'Internal Audit Unit' }, href: '/tentang#struktur' },
    ],
  },
  {
    label: { id: 'Berita', en: 'News' },
    children: [
      { label: { id: 'Berita Terbaru', en: 'Latest News' }, href: '/berita' },
      { label: { id: 'Kegiatan Yayasan', en: 'Foundation Activities' }, href: '/berita' },
      { label: { id: 'Publikasi', en: 'Publications' }, href: '/berita' },
    ],
  },
];

export const heroSlides = [
  {
    id: 0,
    image: '/assets/prabowo.jpg',
    imagePosition: 'center 30%',
    imageFit: 'contain',
    imageBg: '#7a0f19',
    eyebrow: { id: 'PRESIDEN REPUBLIK INDONESIA', en: 'PRESIDENT OF THE REPUBLIC OF INDONESIA' },
    title: { id: 'Prabowo Subianto', en: 'Prabowo Subianto' },
    subtitle: {
      id: 'Di bawah kepemimpinan Presiden Prabowo Subianto, YPPSDP bertekad memperkuat pengembangan potensi sumber daya pertahanan bangsa demi terwujudnya Indonesia yang berdaulat, adil, dan makmur.',
      en: 'Under the leadership of President Prabowo Subianto, YPPSDP is determined to strengthen the development of the nations defense resource potential for a sovereign, just, and prosperous Indonesia.',
    },
    cta: { label: { id: 'Tentang Kami', en: 'About Us' }, href: '/tentang' },
  },
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1608396941316-ea89219bd56e',
    eyebrow: { id: 'YAYASAN PPSDP', en: 'YPPSDP FOUNDATION' },
    title: { id: 'Membangun Kader Pertahanan Bangsa', en: 'Building the Nations Defense Cadres' },
    subtitle: {
      id: 'YPPSDP mengembangkan potensi sumber daya pertahanan Republik Indonesia melalui pendidikan bercirikan Kebangsaan, Kejuangan, dan Kebudayaan bagi generasi muda terbaik nusantara.',
      en: 'YPPSDP develops the defense resource potential of the Republic of Indonesia through education characterized by Nationality, Patriotism, and Culture for the best young generation.',
    },
    cta: { label: { id: 'Selengkapnya', en: 'Learn More' }, href: '/tentang' },
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1719553946838-1190abdeee92',
    eyebrow: { id: 'LPTTN \u2022 SMA TARUNA NUSANTARA', en: 'LPTTN \u2022 SMA TARUNA NUSANTARA' },
    title: { id: 'Menyiapkan Pemimpin Masa Depan', en: 'Preparing Future Leaders' },
    subtitle: {
      id: 'Melalui LPTTN dan SMA Taruna Nusantara di enam kampus, yayasan menyiapkan generasi pemimpin bangsa yang berkarakter kuat dan siap mengabdi bagi Republik Indonesia.',
      en: 'Through LPTTN and SMA Taruna Nusantara across six campuses, the foundation prepares generations of national leaders with strong character, ready to serve the Republic of Indonesia.',
    },
    cta: { label: { id: 'Profil LPTTN', en: 'LPTTN Profile' }, href: '/lpttn' },
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1689182314475-ff55f109b430',
    eyebrow: { id: 'KEMITRAAN STRATEGIS', en: 'STRATEGIC PARTNERSHIP' },
    title: { id: 'Kolaborasi Antar Lembaga', en: 'Inter-Institutional Collaboration' },
    subtitle: {
      id: 'YPPSDP menjalin kerjasama dengan Kementerian Pertahanan RI, pemerintah daerah, dan mitra strategis untuk memperkuat ekosistem pertahanan nasional dan pendidikan kader bangsa.',
      en: 'YPPSDP collaborates with the Ministry of Defense, regional governments, and strategic partners to strengthen the national defense ecosystem and cadre education.',
    },
    cta: { label: { id: 'Lihat Berita', en: 'See News' }, href: '/berita' },
  },
];

export const priorities = {
  image: 'https://images.pexels.com/photos/23625732/pexels-photo-23625732.jpeg',
  headline: {
    id: 'Yayasan Pengembangan Potensi Sumber Daya Pertahanan menaungi LPTTN dan SMA Taruna Nusantara, mengelola tiga direktorat utama—Pendidikan Tinggi, Perumahan & Sosial, serta Investasi & Usaha—didukung Divisi Hukum dan Satuan Pengawas Internal untuk memperkuat pertahanan nasional.',
    en: 'The Foundation for Development of Defense Resource Potential oversees LPTTN and SMA Taruna Nusantara, managing three main directorates—Higher Education, Housing & Social, and Investment & Business—supported by the Legal Division and Internal Audit Unit to strengthen national defense.',
  },
};

export const aboutSection = {
  image: 'https://images.unsplash.com/photo-1661015951889-3cab32166ff8',
  title: { id: 'TENTANG YPPSDP', en: 'ABOUT YPPSDP' },
  href: '/tentang',
};

export const newsSection = {
  image: 'https://images.unsplash.com/photo-1678353888985-6f2659bef53a',
  title: { id: 'BERITA & KEGIATAN', en: 'NEWS & ACTIVITIES' },
  href: '/berita',
};

export const coreValues = {
  title: { id: 'Kebangsaan, Kejuangan, Kebudayaan', en: 'Nationality, Patriotism, Culture' },
  body: [
    {
      id: 'YPPSDP menaungi Lembaga Perguruan Taman Taruna Nusantara (LPTTN) yang mengelola SMA Taruna Nusantara sejak 1990. Sekolah ini didirikan atas gagasan Jenderal TNI L.B. Moerdani untuk mendidik manusia-manusia terbaik dari seluruh Indonesia.',
      en: 'YPPSDP oversees LPTTN which has managed SMA Taruna Nusantara since 1990. The school was founded on the initiative of General L.B. Moerdani to educate the best young people from across Indonesia.',
    },
    {
      id: 'Tiga pilar pendidikan—Kebangsaan, Kejuangan, dan Kebudayaan—menjadi ciri khas pembinaan yang membentuk lulusan berkarakter kuat dan siap melanjutkan cita-cita para Proklamator.',
      en: 'Three educational pillars—Nationality, Patriotism, and Culture—characterize the education that shapes graduates with strong character, ready to continue the ideals of the Founding Fathers.',
    },
  ],
  cta: { label: { id: 'NILAI-NILAI INTI KAMI', en: 'OUR CORE VALUES' }, href: '/tentang#nilai' },
};

export const anniversary = {
  image: 'https://images.pexels.com/photos/38480728/pexels-photo-38480728.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  title: { id: 'SMA Taruna Nusantara — 6 Kampus di Indonesia', en: 'SMA Taruna Nusantara — 6 Campuses in Indonesia' },
  body: [
    {
      id: 'SMA Taruna Nusantara kini hadir di enam kampus di seluruh Indonesia. Setiap tahun, ribuan calon siswa terpilih mengikuti pendidikan dengan pola pengasuhan khas yang memadukan kurikulum nasional dengan pembinaan karakter kepemimpinan.',
      en: 'SMA Taruna Nusantara now operates six campuses across Indonesia. Each year, thousands of selected candidates undergo education combining national curriculum with distinctive leadership character building.',
    },
    {
      id: 'Pada tahun ajaran 2025/2026, sebanyak 1.458 calon siswa dari seluruh nusantara mengikuti Upacara Pembukaan Pendidikan dan Pelantikan Siswa Angkatan ke-36 SMA Taruna Nusantara.',
      en: 'In the 2025/2026 academic year, 1,458 candidates from across the archipelago participated in the Opening Ceremony of Education and Inauguration of the 36th class of SMA Taruna Nusantara students.',
    },
  ],
  cta: { label: { id: 'PROFIL LPTTN', en: 'LPTTN PROFILE' }, href: '/lpttn' },
};

export const leadership = [
  {
    id: 'l1',
    name: 'Mayjen TNI (Purn) Musa Bangun',
    title: { id: 'Ketua Pengurus YPPSDP', en: 'Chairperson of YPPSDP' },
    image: 'https://images.pexels.com/photos/18681298/pexels-photo-18681298.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    bio: {
      id: 'Memimpin Yayasan Pengembangan Potensi Sumber Daya Pertahanan sebagai Ketua Pengurus. Berpengalaman panjang di bidang pembinaan sumber daya pertahanan dan berkomitmen mewujudkan tata kelola yayasan yang bersih, profesional, dan berdampak bagi bangsa.',
      en: 'Serves as Chairperson of the Foundation for Development of Defense Resource Potential. Has extensive experience in defense resource development and is committed to realizing clean, professional, and impactful foundation governance.',
    },
  },
  {
    id: 'l2',
    name: 'Sugiono',
    title: { id: 'Kepala LPTTN', en: 'Head of LPTTN' },
    image: 'https://images.unsplash.com/photo-1622626426572-c268eb006092',
    bio: {
      id: 'Kepala Lembaga Perguruan Taman Taruna Nusantara. Bertanggung jawab atas seluruh penyelenggaraan pendidikan SMA Taruna Nusantara di enam kampus, mulai dari kurikulum, kesiswaan, hingga kerjasama antar lembaga.',
      en: 'Head of Lembaga Perguruan Taman Taruna Nusantara. Responsible for all education activities at SMA Taruna Nusantara across six campuses, including curriculum, student affairs, and inter-institutional cooperation.',
    },
  },
  {
    id: 'l3',
    name: 'Prasetyo Hadi',
    title: { id: 'Wakil Kepala LPTTN', en: 'Deputy Head of LPTTN' },
    image: 'https://images.unsplash.com/photo-1720501828093-c792c10e3f0b',
    bio: {
      id: 'Mendampingi Kepala LPTTN dalam pengelolaan strategis lembaga. Fokus pada pengembangan program pendidikan, hubungan kemitraan dengan pemerintah daerah, serta pengawasan mutu penyelenggaraan pendidikan.',
      en: 'Assists the Head of LPTTN in strategic management of the institution. Focused on educational program development, partnership relations with regional governments, and quality supervision of educational implementation.',
    },
  },
  {
    id: 'l4',
    name: 'Ir. Priscilia Mantiri, MT',
    title: { id: 'Sekretaris LPTTN', en: 'Secretary of LPTTN' },
    image: 'https://images.unsplash.com/photo-1758600587839-56ba05596c69',
    bio: {
      id: 'Sekretaris Lembaga Perguruan Taman Taruna Nusantara. Mengelola administrasi, koordinasi antar unit, serta dokumentasi kebijakan lembaga demi kelancaran operasional pendidikan Taruna Nusantara.',
      en: 'Secretary of Lembaga Perguruan Taman Taruna Nusantara. Manages administration, inter-unit coordination, and policy documentation for smooth operation of Taruna Nusantara education.',
    },
  },
];

export const newsArticles = [
  {
    id: 'n1',
    slug: 'upacara-pelantikan-angkatan-36',
    category: 'PENDIDIKAN',
    date: '14 Juli 2025',
    title: { id: 'Upacara Pendidikan dan Pelantikan Siswa Angkatan ke-36 SMA Taruna Nusantara', en: 'Opening Ceremony and Inauguration of 36th Class Students of SMA Taruna Nusantara' },
    excerpt: {
      id: 'Sebanyak 1.458 calon siswa untuk 6 kampus SMA Taruna Nusantara tahun ajaran 2025/2026 melaksanakan Upacara Pembukaan Pendidikan dan Pelantikan Siswa Angkatan 36.',
      en: 'A total of 1,458 candidates for 6 SMA Taruna Nusantara campuses in the 2025/2026 academic year attended the Opening Ceremony and Inauguration of the 36th class.',
    },
    image: 'https://images.pexels.com/photos/38480728/pexels-photo-38480728.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    gallery: [
      'https://images.pexels.com/photos/38480728/pexels-photo-38480728.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      'https://images.pexels.com/photos/11929778/pexels-photo-11929778.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      'https://images.pexels.com/photos/36961699/pexels-photo-36961699.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    ],
    author: 'Humas LPTTN',
    content: {
      id: 'Kegiatan yang dilaksanakan serentak di enam kampus SMA Taruna Nusantara ini menandai dimulainya tahun ajaran 2025/2026. Para calon siswa yang telah melewati proses seleksi ketat resmi dilantik sebagai siswa angkatan ke-36.\n\nKepala LPTTN Sugiono dalam sambutannya menekankan bahwa pendidikan di SMA Taruna Nusantara mengedepankan tiga pilar—Kebangsaan, Kejuangan, dan Kebudayaan—sebagai fondasi pembentukan karakter pemimpin masa depan.',
      en: 'The event held simultaneously at six SMA Taruna Nusantara campuses marks the beginning of the 2025/2026 academic year. Candidates who passed the strict selection process were officially inaugurated as 36th class students.\n\nHead of LPTTN Sugiono in his remarks emphasized that education at SMA Taruna Nusantara upholds three pillars—Nationality, Patriotism, and Culture—as the foundation for building future leader character.',
    },
  },
  {
    id: 'n2',
    slug: 'kunjungan-staf-ahli-kasad',
    category: 'KEMITRAAN',
    date: '28 Juli 2025',
    title: { id: 'Kunjungan Staf Ahli KASAD ke LPTTN', en: 'KASAD Special Staff Visit to LPTTN' },
    excerpt: {
      id: 'Staf Ahli Kepala Staf Angkatan Darat berkunjung ke LPTTN untuk membahas sinergi dengan pendidikan Taruna Nusantara.',
      en: 'The Special Staff of KASAD visited LPTTN to discuss synergy with Taruna Nusantara education.',
    },
    image: 'https://images.unsplash.com/photo-1608396941316-ea89219bd56e',
    gallery: [
      'https://images.unsplash.com/photo-1608396941316-ea89219bd56e',
      'https://images.unsplash.com/photo-1637594439849-40ef084de32f',
    ],
    author: 'Humas LPTTN',
    content: {
      id: 'Kunjungan ini menjadi momentum penting bagi penguatan kerjasama LPTTN dengan lembaga pertahanan. Pembahasan mencakup peran pamong pengajar serta program pengembangan karakter kejuangan bagi siswa.\n\nKepala LPTTN menyampaikan bahwa dukungan lembaga pertahanan selama ini sangat berperan dalam menjaga kualitas pembinaan siswa.',
      en: 'This visit became an important momentum for strengthening LPTTN cooperation with defense institutions. Discussions covered the role of teaching officers and character development programs for students.\n\nHead of LPTTN conveyed that support from defense institutions has played a significant role in maintaining student development quality.',
    },
  },
  {
    id: 'n3',
    slug: 'mou-babel-lpttn',
    category: 'MoU',
    date: '15 Juli 2024',
    title: { id: 'Penandatanganan MoU antara LPTTN dan Provinsi Bangka Belitung', en: 'MoU Signing between LPTTN and Bangka Belitung Province' },
    excerpt: {
      id: 'LPTTN dan Pemprov Bangka Belitung menandatangani nota kesepahaman untuk penyediaan beasiswa siswa daerah di SMA Taruna Nusantara.',
      en: 'LPTTN and the Bangka Belitung Provincial Government sign an MoU for regional student scholarships at SMA Taruna Nusantara.',
    },
    image: 'https://images.unsplash.com/photo-1719553946838-1190abdeee92',
    gallery: ['https://images.unsplash.com/photo-1719553946838-1190abdeee92', 'https://images.unsplash.com/photo-1708342421457-9c59f4843fe1'],
    author: 'Humas LPTTN',
    content: {
      id: 'Penandatanganan ini menunjukkan bahwa LPTTN ingin memberikan kontribusi yang besar bagi daerah-daerah di Indonesia. Kerjasama mencakup penyediaan kuota beasiswa untuk putra-putri terbaik Bangka Belitung.',
      en: 'This signing shows that LPTTN wants to make a significant contribution to regions in Indonesia. The cooperation includes providing scholarship quotas for the best sons and daughters of Bangka Belitung.',
    },
  },
  {
    id: 'n4',
    slug: 'muhibah-korea-selatan',
    category: 'MUHIBAH',
    date: '20 Mei 2024',
    title: { id: 'Muhibah SMA Taruna Nusantara ke Korea Selatan', en: 'SMA Taruna Nusantara Goodwill Mission to South Korea' },
    excerpt: {
      id: 'Rombongan LPTTN mengunjungi Air Force Aviation (AFA) Science High School di Korea Selatan untuk pertukaran wawasan pendidikan.',
      en: 'LPTTN delegation visits Air Force Aviation (AFA) Science High School in South Korea for educational exchange.',
    },
    image: 'https://images.unsplash.com/photo-1689182314475-ff55f109b430',
    gallery: ['https://images.unsplash.com/photo-1689182314475-ff55f109b430', 'https://images.unsplash.com/photo-1583133269464-b721db5345f4'],
    author: 'Humas LPTTN',
    content: {
      id: 'Kunjungan ini memperluas wawasan siswa Taruna Nusantara mengenai pendidikan berbasis kedirgantaraan di negara sahabat. Beberapa program pertukaran akademik akan dijajaki lebih lanjut.',
      en: 'This visit broadens the perspective of Taruna Nusantara students on aerospace-based education in a friendly nation. Several academic exchange programs will be further explored.',
    },
  },
  {
    id: 'n5',
    slug: 'courtesy-call-itjen-kemhan',
    category: 'KEMITRAAN',
    date: '10 September 2024',
    title: { id: 'Itjen Kemhan Melaksanakan Courtesy Call ke YPPSDP', en: 'Inspectorate General of MoD Conducts Courtesy Call to YPPSDP' },
    excerpt: {
      id: 'Inspektorat Jenderal Kemhan RI melakukan kunjungan kehormatan ke kantor YPPSDP.',
      en: 'The Inspectorate General of MoD visited YPPSDP office.',
    },
    image: 'https://images.pexels.com/photos/13128624/pexels-photo-13128624.jpeg',
    gallery: ['https://images.pexels.com/photos/13128624/pexels-photo-13128624.jpeg'],
    author: 'Humas YPPSDP',
    content: {
      id: 'Ketua Pengurus YPPSDP Mayjen TNI (Purn) Musa Bangun menyambut kunjungan Inspektorat Jenderal Kementerian Pertahanan. Pertemuan membahas tata kelola dan transparansi pelaporan yayasan.',
      en: 'YPPSDP Chairperson Mayjen TNI (Ret) Musa Bangun welcomed the visit of the Inspectorate General of the Ministry of Defense. The meeting discussed governance and reporting transparency.',
    },
  },
  {
    id: 'n6',
    slug: 'sosialisasi-humas-nias-selatan',
    category: 'SOSIALISASI',
    date: '05 Juni 2024',
    title: { id: 'Sosialisasi Kabid Humas LPTTN di Polres Nias Selatan', en: 'LPTTN PR Head Socialization at Nias Selatan Police' },
    excerpt: {
      id: 'Kabid Humas LPTTN menyosialisasikan program penerimaan siswa baru di wilayah Nias Selatan.',
      en: 'LPTTN PR Head socializes new student admission program in Nias Selatan region.',
    },
    image: 'https://images.pexels.com/photos/23625732/pexels-photo-23625732.jpeg',
    gallery: ['https://images.pexels.com/photos/23625732/pexels-photo-23625732.jpeg'],
    author: 'Humas LPTTN',
    content: {
      id: 'LPTTN aktif menjangkau daerah-daerah untuk memberikan kesempatan setara bagi seluruh putra-putri terbaik Indonesia dalam mengikuti seleksi SMA Taruna Nusantara.',
      en: 'LPTTN actively reaches out to regions to provide equal opportunities for all the best young people of Indonesia to participate in SMA Taruna Nusantara selection.',
    },
  },
];

export const smatnCampuses = [
  { name: 'SMA TN Magelang', city: 'Magelang, Jawa Tengah', year: '1990', desc: { id: 'Kampus induk didirikan tahun 1990, di atas lahan 23 hektare.', en: 'The main campus established in 1990, on 23 hectares.' } },
  { name: 'SMA TN Bogor', city: 'Bogor, Jawa Barat', year: '2020', desc: { id: 'Kampus kedua yang menerima siswa putra-putri terbaik.', en: 'The second campus admitting the best students.' } },
  { name: 'SMA TN Sragen', city: 'Sragen, Jawa Tengah', year: '2022', desc: { id: 'Kampus ekspansi wilayah tengah Jawa.', en: 'Expansion campus in Central Java.' } },
  { name: 'SMA TN Cimahi', city: 'Cimahi, Jawa Barat', year: '2023', desc: { id: 'Kampus TN di kawasan pendidikan militer Cimahi.', en: 'TN campus in Cimahi military education area.' } },
  { name: 'SMA TN Palembang', city: 'Palembang, Sumatera Selatan', year: '2024', desc: { id: 'Kampus TN pertama di Sumatera.', en: 'First TN campus in Sumatra.' } },
  { name: 'SMA TN Balikpapan', city: 'Balikpapan, Kalimantan Timur', year: '2024', desc: { id: 'Kampus TN di kawasan Ibu Kota Nusantara.', en: 'TN campus in the Nusantara Capital area.' } },
];

export const quickLinks = {
  id: ['Struktur Organisasi', 'Pengurus', 'LPTTN', 'SMA Taruna Nusantara', 'Berita', 'Kontak'],
  en: ['Organization', 'Leadership', 'LPTTN', 'SMA Taruna Nusantara', 'News', 'Contact'],
};

export const footerLinks = {
  id: {
    'Tentang': ['Sejarah', 'Visi & Misi', 'Struktur Organisasi', 'Nilai Inti'],
    'LPTTN': ['Profil LPTTN', 'SMA Taruna Nusantara', 'Sejarah', 'Penerimaan Siswa'],
    'Direktorat': ['Pendidikan Tinggi', 'Perumahan & Sosial', 'Investasi & Usaha', 'Divisi Hukum'],
    'Publikasi': ['Berita', 'Galeri', 'Dokumen', 'Kontak'],
  },
  en: {
    'About': ['History', 'Vision & Mission', 'Organization', 'Core Values'],
    'LPTTN': ['LPTTN Profile', 'SMA Taruna Nusantara', 'History', 'Admission'],
    'Directorates': ['Higher Education', 'Housing & Social', 'Investment & Business', 'Legal Division'],
    'Publications': ['News', 'Gallery', 'Documents', 'Contact'],
  },
};
